import { __awaiter, __generator } from "tslib";
import { axios } from '../axios';
import { getPostEventBody, getError } from './utils';
export function postEvents(_a) {
    var clientId = _a.clientId, version = _a.version, sessionId = _a.sessionId, eventType = _a.eventType, opts = _a.opts, previewQuery = _a.previewQuery, apiUrlConfig = _a.apiUrlConfig, requestTimeout = _a.requestTimeout;
    return __awaiter(this, void 0, void 0, function () {
        var eventBody, data, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    eventBody = getPostEventBody({
                        eventType: eventType,
                        opts: opts,
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios({
                            method: 'POST',
                            url: "".concat(apiUrlConfig, "/v3/web/events"),
                            data: eventBody,
                            headers: {
                                'X-RMC-Client-ID': clientId,
                                'X-RMC-Session': sessionId,
                                'X-RMC-SDK-Version': version,
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                            },
                            params: previewQuery,
                            withCredentials: true,
                            timeout: requestTimeout,
                        })];
                case 2:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    e_1 = _b.sent();
                    throw getError(e_1);
                case 4: return [2 /*return*/];
            }
        });
    });
}
